<template>
  <div v-if="partialRepartition">
    <strong>{{ $t('detail.commande.repartitionMontants.title') }} {{ repartitionLabel }}</strong>
    <div class="mgt-10px VueTables">
      <div class="table-responsive">
        <table class="VueTables__table table is-striped-reverse is-fullwidth">
          <tbody>
          <tr>
            <td></td>
            <td>{{ $t('detail.commande.recapitulatifMontants.totalHt') }}</td>
            <td class="right"><strong>{{ payeur.montantsRepartition.ht }}</strong></td>
          </tr>
          <tr>
            <td></td>
            <td>{{ $t('detail.commande.recapitulatifMontants.tva') }}</td>
            <td class="right">{{ payeur.montantsRepartition.tva }}</td>
          </tr>
          <tr class="total-ttc">
            <td></td>
            <td>{{ $t('detail.commande.recapitulatifMontants.totalTtc') }}</td>
            <td class="right">{{ payeur.montantsRepartition.ttc }}</td>
          </tr>
          <tr v-if='filteredAcomptes.length'>
            <td></td>
            <td>{{ $t('detail.commande.recapitulatifMontants.acompte')  }}</td>
            <td class='right'>-{{ totalAcomptes | formatDevise }}</td>
          </tr>
          <tr v-if='filteredAcomptes.length' class="total-ttc">
            <td></td>
            <td>{{ $t('detail.commande.recapitulatifMontants.netAPayer') }}</td>
            <td class="right">{{ netAPayer | formatDevise }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import * as devisConf from '@/configuration/devisConf';
import { formatDevise } from '@/services/general/filters/formatDevise';

export default {
  props: {
    acomptes: {
      type: Array,
      default: () => [],
    },
    recapitulatif: {
      type: Object,
    },
    payeur: {
      type: Object,
      required: true,
    },
  },
  computed: {
    filteredAcomptes() {
      return this.payeur && this.acomptes ? this.acomptes.filter(a => {
        return a.tiersId === this.payeur.tiersId;
      }) : [];
    },
    totalAcomptes() {
      return this.filteredAcomptes.reduce((acc, curr) => {
        const total = acc + curr.montantTtc;
        return total;
      }, 0);
    },
    repartitionPourcentage() {
      return this.payeur.typeRepartition === devisConf.POURCENTAGE;
    },
    partialRepartition() {
      return !(this.payeur.repartition === 100 && this.repartitionPourcentage);
    },
    repartitionLabel() {
      if (!this.repartitionPourcentage) return formatDevise(this.payeur.repartition);
      return this.payeur.repartition.toFixed(2) + '%';
    },
    netAPayer() {
      return Number.parseFloat(this.payeur.montantsRepartition.ttc) - this.totalAcomptes;
    },
  },
};
</script>
